import { Button, Flex, Text } from "@chakra-ui/react";

import JSZip from "jszip";
import { saveAs } from "file-saver";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

export const formatTableValue = (value, key, code) => {
  switch (key) {
    case "isBusiness":
      return (
        <Flex gap={"8px"} w={"max-content"}>
          <Text
            color={
              value === 1
                ? "var(--color-secondary2)"
                : "var(--color-status-employ)"
            }
          >
            {value === 1 ? "Doanh nghiệp" : "Cá nhân"}
          </Text>
        </Flex>
      );
    case "contact":
      return (
        <>
          <Text>{value.phone}</Text>
          <Text>{value.email}</Text>
        </>
      );
    case "identificationInfo":
      return (
        <>
          <Text>{value.career}</Text>
          <Text>{value.permanentAddress}</Text>
          <Text>{value.currentAddress}</Text>
        </>
      );
    case "identificationInfoBusiness":
      return (
        <>
          <Text>{value.businessRegistrationPlace}</Text>
          <Text>{value.representativeName}</Text>
          <Text>{value.representativeGender}</Text>
          <Text>{value.representativePosition}</Text>
          <Text>{value.representativeIdNumber}</Text>
        </>
      );
    case "project":
      return (
        <>
          {value && value.length > 0
            ? value.map((project, index) => (
                <Text key={index}>
                  {project}{" "}
                  {index < value.length && value.length > 1 ? "," : ""}
                </Text>
              ))
            : "-"}
        </>
      );

    case "idCardFrontImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh CCCD mặt trước của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "idCardBackImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh CCCD mặt sau của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "vnidImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(value, `ảnh VNID của ${code ? `${code}` : ""}`)
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "idRepresentativeCardFrontImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh CCCD mặt trước NĐD của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "idRepresentativeCardBackImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh CCCD mặt sau NĐD của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "representativeVnidImage":
      if (!value) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `ảnh VNID NĐD của ${code ? `${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "businessRegistrationImage":
      if (!value || value?.length == 0) return <Text>{`Không có ảnh`}</Text>;
      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `anh_dang_ky_kinh_doanh${code ? `_${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );
    default:
      return <Text display={"inline"}>{value}</Text>;
  }
};

export const downloadImageOrZip = async (input, name) => {
  const URL = baseURL + "/";
  if (typeof input === "string") {
    // Trường hợp 1 URL đơn
    try {
      const response = await fetch(URL + input);
      const blob = await response.blob();
      let filename;
      if (name) {
        filename = name.endsWith(".jpg") ? name : name + ".jpg";
      } else {
        const original = input.split("/").pop()?.split(".")[0] || "image";
        filename = `${original}.jpg`;
      }
      saveAs(blob, filename);
    } catch (error) {
      console.error("Lỗi khi tải ảnh:", error);
    }
  } else if (Array.isArray(input)) {
    // Trường hợp mảng URL → zip
    const zip = new JSZip();
    for (const url of input) {
      try {
        const response = await fetch(URL + url);
        const blob = await response.blob();

        // Ép ảnh thành .jpg bất kể đuôi thật
        const originalName = url.split("/").pop()?.split(".")[0] || "image";
        const filename = `${originalName}.jpg`;

        zip.file(filename, blob);
      } catch (error) {
        console.error("Lỗi khi tải ảnh:", url, error);
      }
    }
    try {
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `${name ? name : "anh_hdmb.zip"}`);
    } catch (zipError) {
      console.error("Lỗi khi tạo file ZIP:", zipError);
    }
  } else {
    console.warn("Input không hợp lệ: phải là chuỗi hoặc mảng chuỗi.");
  }
};
